import { ActionReducerMapBuilder, PayloadAction, createSlice } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  fetchFormulaData,
  fetchGetHubQuota,
  fetchGetListLocationQuota,
  fetchHistoryQuota,
  SLICE_NAME,
} from './thunk'
import { Quota3PLInitialStateType } from './types'

export const initialState: Quota3PLInitialStateType = {
  isLoading: false,
  isLoadingOverlay: false,
  showPopupAdd: false,
  listLocation: [],
  locationSelected: null,
  quotaDaily: {
    location_id: '',
    location_name: '',
    quota_infos: [],
  },
  allocationHistory: [],
  selectedTimestamp: Date.now(),
  historyHasData: true,
  quotaAvailableInLocation: 0,
}

const quota3PLSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setIsLoadingOverlay: (state, action: PayloadAction<boolean>) => {
      state.isLoadingOverlay = action.payload
    },
    setLocationSelected: (
      state,
      action: PayloadAction<Quota3PLInitialStateType['locationSelected']>,
    ) => {
      state.locationSelected = action.payload
    },
    setShowPopupAdd: (state, action: PayloadAction<boolean>) => {
      state.showPopupAdd = action.payload
    },
    setPrevTimestamp: (state) => {
      state.selectedTimestamp -= 24 * 60 * 60 * 1000
    },
    setNextTimestamp: (state) => {
      state.selectedTimestamp += 24 * 60 * 60 * 1000
    },
    resetQuotaDaily: (state) => {
      state.quotaDaily = initialState.quotaDaily
      state.locationSelected = initialState.locationSelected
    },
    resetAllocationHistory: (state) => {
      state.allocationHistory = initialState.allocationHistory
    },
    setQuotaAvailableInLocation: (state, action: PayloadAction<number>) => {
      state.quotaAvailableInLocation = action.payload
    },
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<Quota3PLInitialStateType>) => {
      builder.addCase(fetchGetListLocationQuota.fulfilled, (state, action) => {
        state.listLocation = action.payload.data.filter(
          (location) => location.location_type.toLowerCase() !== 'warehouse',
        )
      })
      builder.addCase(fetchGetHubQuota.fulfilled, (state, action) => {
        state.quotaDaily = action.payload
      })
      builder.addCase(fetchHistoryQuota.fulfilled, (state, action) => {
        if (action.payload.data.quota_histories.length === 0) {
          state.historyHasData = false
        }
        if (state.historyHasData) {
          state.allocationHistory = [
            ...state.allocationHistory,
            ...action.payload.data.quota_histories,
          ]
        }
      })
      builder.addCase(fetchFormulaData.pending, (state) => {
        state.isLoadingOverlay = true
      })
      builder.addCase(fetchFormulaData.rejected, (state) => {
        state.isLoadingOverlay = false
      })
      builder.addCase(fetchFormulaData.fulfilled, (state) => {
        state.isLoadingOverlay = false
      })
    },
    [fetchGetListLocationQuota, fetchGetHubQuota, fetchHistoryQuota, fetchFormulaData],
  ),
})

export const {
  setLocationSelected,
  setIsLoadingOverlay,
  setShowPopupAdd,
  setPrevTimestamp,
  setNextTimestamp,
  resetQuotaDaily,
  resetAllocationHistory,
  setQuotaAvailableInLocation,
} = quota3PLSlice.actions
export default quota3PLSlice.reducer
